import { graphql } from 'gatsby'
import React from 'react'

import CenteredCallToAction from '@/components/centered-call-to-action/centered-call-to-action'

const FeaturedCta: React.FC<Queries.FeaturedCtaFragment> = ({
  title,
  subtitle,
  cta,
  width
}) => {
  return (
    <CenteredCallToAction
      title={title ?? ''}
      subtitle={subtitle ?? ''}
      cta={cta ?? undefined}
      width={width as 'small' | 'medium' | 'full'}
    />
  )
}

export default FeaturedCta

export const query = graphql`
  fragment FeaturedCta on DatoCmsFeaturedCta {
    __typename
    id
    title
    subtitle
    width
    navigationLabel
    cta {
      ... on DatoCmsCta {
        ...Cta
      }
    }
  }
`
